module.exports = __webpack_public_path__ + "img/banner1.797c28c0.jpg";